import type { AppLocale } from "@repo/client/format";
import type { PlanSplit } from "@repo/contract/training";
import {
  "plan.split.custom" as splitCustom,
  "plan.split.full_body" as splitFullBody,
  "plan.split.ppl" as splitPpl,
  "plan.split.ppl_arms" as splitPplArms,
  "plan.split.upper_lower" as splitUpperLower,
} from "@repo/i18n";

/**
 * The week's shape, as the person reads it (`D213`).
 *
 * The plan's header used to name the PROTOCOL — "Full body iniciante" — over
 * a week the engine had built as upper/lower, because the beginner protocols
 * derive their split from the day count and their name said one of the three
 * it could become. The server now says which split it built
 * (`planView.split`), and this names it. A whole-literal record rather than a
 * key built at runtime, so a split with no copy is a type error.
 */
const SPLIT_NAME: Record<PlanSplit, typeof splitCustom> = {
  custom: splitCustom,
  full_body: splitFullBody,
  ppl: splitPpl,
  ppl_arms: splitPplArms,
  upper_lower: splitUpperLower,
};

export function splitName(split: PlanSplit, locale: AppLocale): string {
  return SPLIT_NAME[split]({}, { locale });
}
